
import { Vue } from "vue-class-component";

class LeaderboardNewcomerIcon extends Vue {}
export default LeaderboardNewcomerIcon;
